var _rect, _path, _circle;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTwo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 420,
    height: 420,
    viewBox: "0 0 420 420",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 420,
    height: 420,
    fill: "#E4F5FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M66.3076 228.546C66.3076 209.716 70.0166 191.069 77.2227 173.672C84.4289 156.275 94.9911 140.467 108.306 127.152C121.622 113.837 137.429 103.275 154.826 96.0684C172.224 88.8623 190.87 85.1533 209.701 85.1533C228.531 85.1533 247.177 88.8623 264.575 96.0685C281.972 103.275 297.779 113.837 311.095 127.152C324.41 140.467 334.972 156.275 342.178 173.672C349.384 191.069 353.093 209.716 353.093 228.546L209.7 228.546L66.3076 228.546Z",
    fill: "#FF7D85"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 209.7,
    cy: 228.55,
    r: 94.4169,
    transform: "rotate(90 209.7 228.55)",
    fill: "#47BDFF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwo);
export default __webpack_public_path__ + "static/media/two.ebe1063593ad262d8a510b7d3c5fae35.svg";
export { ForwardRef as ReactComponent };